// import { useCallback, useEffect, useState } from "react";
// import { Box, CircularProgress, Container, Grid, IconButton, Paper, Typography, Checkbox, Snackbar, useTheme, useMediaQuery, Tooltip, Alert } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { VscNewFile } from "react-icons/vsc";
// import { FaFileExcel, FaTrash } from 'react-icons/fa';
// import { useAuth } from '../context/AuthContext';

// const PAGE_LIMIT = 50;

// export default function UserDetailsPage_v3({ connectionString }) {

//     const { user, selectedCompany } = useAuth();
//     const API_BASE = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const userCategory = user?.UserCategory || null;

//     const [searchData, setSearchData] = useState({
//         UserName: "",
//         EmployeeName: "",
//         MobileNo: "",
//         emailId: "",
//     });

//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [notification, setNotification] = useState("");
//     const [selectedIds, setSelectedIds] = useState([]);
//     const [selectedRows, setSelectedRows] = useState([]);
//     const [selectedRowIds, setSelectedRowIds] = useState([]);


//     const fetchUsers = useCallback(async (filters = searchData) => {
//         if (!companyId) return;
//         setLoading(true);
//         try {
//             const { data: res } = await axios.get(`${API_BASE}/api/userssearch`, {
//                 params: {
//                     companyId,
//                     offset: 0,
//                     limit: PAGE_LIMIT,
//                     ...filters,
//                 },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });
//             if (res.success) {
//                 console.log(res.users)
//                 setUsers(res.users || []);
//             } else {
//                 setNotification("Failed to fetch users");
//             }
//         } catch (err) {
//             console.error("Fetch error:", err);
//             setNotification("Server error");
//         } finally {
//             setLoading(false);
//         }
//     }, [companyId, searchData]);

//     useEffect(() => { fetchUsers(); }, [fetchUsers]);

//     const funExportData = async () => {
//         try {
//             const res = await axios({
//                 url: `${API_BASE}/api/export-users?companyId=${companyId}`,
//                 method: 'GET',
//                 responseType: 'blob',
//             });
//             const url = window.URL.createObjectURL(new Blob([res.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'UserDetailsExport.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (err) {
//             console.error("Export failed:", err);
//             setNotification("Export failed.");
//         }
//     };

//     const goToEdit = (id) => navigate("/main/usermaster", { state: { mode: "edit", UserId: id } });
//     const addNewUser = () => navigate("/main/usermaster", { state: { mode: "insert" } });

//     const handleDelete = async (UserId) => {
//         if ( userCategory === 'user') {
//             setNotification("403 Unauthorized");
//             return;
//         }

//         const idsToDelete = UserId ? [Number(UserId)] : selectedIds.map(Number);

//         if (!idsToDelete.length) {
//             setNotification("No users selected");
//             return;
//         }

//         try {
//             const chk = await axios.post(`${API_BASE}/api/check-inquiry`, { userIds: idsToDelete });
//             if (chk.status === 400) {
//                 setNotification("Cannot delete: inquiries exist");
//                 return;
//             }

//             const del = await axios.post(`${API_BASE}/api/delete-users`, { userIds: idsToDelete, companyId });
//             if (del.data.success) {
//                 setUsers(prev => prev.filter(u => !idsToDelete.includes(u.UserId)));
//                 setSelectedIds((prev) => prev.filter((id) => !idsToDelete.includes(id)));
//                 setNotification("Users deleted successfully");
//                 fetchUsers();
//             } else {
//                 setNotification(del.data.message || "Delete failed");
//             }
//         } catch (err) {
//             console.error("Delete error:", err);
//             setNotification("Server error while deleting");
//         }
//     };

//     const handleSelectionChange = (newSelectionModel) => {
//         // If header checkbox is checked (selectedIds has items), prevent unchecking individual rows
//         if (selectedIds.length > 0 && newSelectionModel.length < selectedIds.length) {
//             // Keep the current selection if trying to uncheck a row
//             return;
//         }
//         // Update selection if header checkbox is unchecked or rows are being added
//         setSelectedIds(newSelectionModel.map(String));
//     };

//     const columns = [
//         {
//             field: "select",
//             headerName: "",
//             width: 40,
//             sortable: false,
//             disableColumnMenu: true,
//             renderHeader: () => {
//                 const allSelected =
//                     users.length > 0 &&
//                     users.every((row) => selectedRowIds.includes(Number(row.UserId)));
//                 const someSelected = selectedRowIds.length > 0 && !allSelected;

//                 return (
//                     <Checkbox
//                         checked={allSelected}
//                         indeterminate={someSelected}
//                         onChange={(e) => {
//                             if (e.target.checked) {
//                                 setSelectedRows(users);
//                                 setSelectedRowIds(users.map((r) => Number(r.UserId)));
//                             } else {
//                                 setSelectedRows([]);
//                                 setSelectedRowIds([]);
//                             }
//                         }}
//                     />
//                 );
//             },
//             renderCell: ({ row }) => {
//                 const rowIdNum = Number(row.UserId);
//                 const checked = selectedRowIds.includes(rowIdNum);

//                 return (
//                     <Checkbox
//                         checked={checked}
//                         onChange={(e) => {
//                             const checkedNow = e.target.checked;
//                             setSelectedRows((prevRows) => {
//                                 if (checkedNow) {
//                                     if (prevRows.some((r) => r.UserId === row.UserId)) return prevRows;
//                                     const newRows = [...prevRows, row];
//                                     setSelectedRowIds(newRows.map((r) => Number(r.UserId)));
//                                     return newRows;
//                                 } else {
//                                     const newRows = prevRows.filter((r) => r.UserId !== row.UserId);
//                                     setSelectedRowIds(newRows.map((r) => Number(r.UserId)));
//                                     return newRows;
//                                 }
//                             });
//                         }}
//                     />
//                 );
//             },
//         },
//         {
//             field: "UserName", headerName: "User Name", flex: 1,
//             renderCell: (params) => (
//                 <Typography variant="body2" color="primary" sx={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => goToEdit(params.row.UserId)} >
//                     {params.value}
//                 </Typography>
//             ),
//         },
//         { field: "EmployeeName", headerName: "Employee Name", flex: 1 },
//         { field: "MobileNo", headerName: "Mobile Number", flex: 1 },
//         { field: "emailId", headerName: "Email", flex: 1 },
//         { field: "UserCategory", headerName: "Category", flex: 1 },
//         {
//             field: "actions",
//             headerName: "Actions",
//             flex: 0.35,
//             sortable: false,
//             headerAlign: "right",
//             align: "right",
//             renderCell: (params) => (
//                 <Tooltip title="Delete User">
//                     <span>
//                         <IconButton
//                             data-userid={params.row.UserId}
//                             onClick={(e) =>
//                                 handleDelete(e.currentTarget.getAttribute("data-userid"))
//                             }
//                             disabled={!selectedRowIds.includes(Number(params.row.UserId))}
//                             color="error"
//                         >
//                             <FaTrash />
//                         </IconButton>
//                     </span>
//                 </Tooltip>
//             ),
//         },
//     ];

//     return (
//         <Container sx={{ pt: 1, }}>
//             <Box display="flex" justifyContent="space-between" alignItems="center">
//                 <Box>
//                     <Tooltip title="Add New">
//                         <IconButton onClick={addNewUser} sx={{ color: 'orange' }}>
//                             <VscNewFile />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Export to Excel">
//                         <IconButton onClick={funExportData} color="success">
//                             <FaFileExcel />
//                         </IconButton>
//                     </Tooltip>
//                 </Box>
//                 <Typography variant="h5" sx={{ flex: 1 }} align="center" gutterBottom>User Details</Typography>
//             </Box>

//             {/* DataGrid */}
//             {loading ? (
//                 <Box textAlign="center" py={4}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <Paper sx={{ bgcolor: '#fff', borderRadius: 2 }}>
//                     <Box sx={{ maxHeight: '84vh', maxWidth: '100%', overflow: 'auto' }}>
//                         <DataGrid
//                             rows={users}
//                             columns={columns}
//                             getRowId={(row) => row.UserId}
//                             pagination={false}
//                             autoHeight
//                             sx={{
//                                 /* header background */
//                                 '& .MuiDataGrid-columnHeaders': {
//                                     backgroundColor: '#165bb5',
//                                     color: '#FFFFFF',
//                                     fontWeight: 'bold',
//                                 },

//                                 /* header text (cell title) */
//                                 '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-columnHeaderTitleContainer': {
//                                     color: '#FFFFFF', // ensures header text is white
//                                 },

//                                 /* all SVG icons inside header cells (generic) */
//                                 '& .MuiDataGrid-columnHeader .MuiSvgIcon-root': {
//                                     color: '#FFFFFF !important',
//                                     opacity: 1,
//                                 },

//                                 /* header icon buttons (container for three-dots menu button, etc.) */
//                                 '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
//                                     color: '#FFFFFF !important',
//                                     opacity: 1,
//                                 },

//                                 /* specific DataGrid icon classes (menu/filter/sort) */
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
//                                     color: '#FFFFFF !important',
//                                     opacity: 1,
//                                 },

//                                 /* Force the SVG path/fill to pure white for sort icon specifically */
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon svg path': {
//                                     fill: '#FFFFFF !important',
//                                     stroke: '#FFFFFF !important',
//                                     color: '#FFFFFF !important',
//                                     opacity: 1,
//                                 },

//                                 /* Ensure other icons (menu/filter) remain white */
//                                 '& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon svg path, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon svg path': {
//                                     fill: '#FFFFFF !important',
//                                     stroke: '#FFFFFF !important',
//                                     opacity: 1,
//                                 },

//                                 /* keep row striping */
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },

//                                 /* remove header focus outline */
//                                 '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
//                                     outline: 'none',
//                                 },
//                             }}
//                         />
//                     </Box>
//                 </Paper>
//             )}

//             {/* Snackbar */}
//             <Snackbar open={!!notification} onClose={() => setNotification("")} autoHideDuration={3000} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} >
//                 <Alert onClose={() => setNotification("")} severity={notification.toLowerCase().includes("unauthorized") ? "warning" : notification.toLowerCase().includes("fail") || notification.toLowerCase().includes("error") ? "error" : "success"}
//                     sx={{
//                         backgroundColor: notification.toLowerCase().includes("unauthorized") ? '#ff69b4' : undefined,
//                         color: notification.toLowerCase().includes("unauthorized") ? 'white' : undefined,
//                         fontWeight: 'bold',
//                     }}
//                 >
//                     {notification}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// }




// import { useCallback, useEffect, useState } from "react";
// import {
//     Box,
//     CircularProgress,
//     Container,
//     Grid,
//     IconButton,
//     Paper,
//     Typography,
//     Checkbox,
//     Snackbar,
//     useTheme,
//     useMediaQuery,
//     Tooltip,
//     Alert,
//     Card,
//     CardContent,
//     Avatar,
//     TextField,
//     InputAdornment,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { VscNewFile } from "react-icons/vsc";
// import { FaFileExcel, FaTrash } from "react-icons/fa";
// import SearchIcon from "@mui/icons-material/Search";
// import DeleteIcon from "@mui/icons-material/Delete";
// import PhoneIcon from "@mui/icons-material/Phone";
// import EmailIcon from "@mui/icons-material/Email";
// import PersonIcon from "@mui/icons-material/Person";
// import CategoryIcon from "@mui/icons-material/Category";
// import { useAuth } from "../context/AuthContext";

// const PAGE_LIMIT = 50;

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ["#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6", "#1abc9c", "#3f51b5", "#e91e63", "#795548", "#00bcd4"];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return "U";
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function UserDetailsPage_v3({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const API_BASE = connectionString;
//     const navigate = useNavigate();
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const userCategory = user?.UserCategory || null;

//     const [users, setUsers] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [notification, setNotification] = useState("");
//     const [selectedIds, setSelectedIds] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");

//     const fetchUsers = useCallback(async () => {
//         if (!companyId) return;
//         setLoading(true);
//         try {
//             const { data: res } = await axios.get(`${API_BASE}/api/userssearch`, {
//                 params: {
//                     companyId,
//                     offset: 0,
//                     limit: PAGE_LIMIT,
//                 },
//                 headers: { "Cache-Control": "no-store" },
//             });
//             if (res.success) {
//                 setUsers(res.users || []);
//             } else {
//                 setNotification("Failed to fetch users");
//             }
//         } catch (err) {
//             console.error("Fetch error:", err);
//             setNotification("Server error");
//         } finally {
//             setLoading(false);
//         }
//     }, [companyId, API_BASE]);

//     useEffect(() => {
//         fetchUsers();
//     }, [fetchUsers]);

//     const funExportData = async () => {
//         try {
//             const res = await axios({
//                 url: `${API_BASE}/api/export-users?companyId=${companyId}`,
//                 method: "GET",
//                 responseType: "blob",
//             });
//             const url = window.URL.createObjectURL(new Blob([res.data]));
//             const link = document.createElement("a");
//             link.href = url;
//             link.setAttribute("download", "UserDetailsExport.xlsx");
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (err) {
//             console.error("Export failed:", err);
//             setNotification("Export failed.");
//         }
//     };

//     const goToEdit = (id) => navigate("/main/usermaster", { state: { mode: "edit", UserId: id } });
//     const addNewUser = () => navigate("/main/usermaster", { state: { mode: "insert" } });

//     const handleDelete = async (UserId) => {
//         if (userCategory === "user") {
//             setNotification("403 Unauthorized");
//             return;
//         }
//         const idsToDelete = UserId ? [Number(UserId)] : selectedIds.map(Number);
//         if (!idsToDelete.length) {
//             setNotification("No users selected");
//             return;
//         }
//         try {
//             const chk = await axios.post(`${API_BASE}/api/check-inquiry`, { userIds: idsToDelete });
//             if (chk.status === 400) {
//                 setNotification("Cannot delete: inquiries exist");
//                 return;
//             }
//             const del = await axios.post(`${API_BASE}/api/delete-users`, { userIds: idsToDelete, companyId });
//             if (del.data.success) {
//                 setUsers((prev) => prev.filter((u) => !idsToDelete.includes(u.UserId)));
//                 setSelectedIds((prev) => prev.filter((id) => !idsToDelete.includes(id)));
//                 setNotification("Users deleted successfully");
//                 fetchUsers();
//             } else {
//                 setNotification(del.data.message || "Delete failed");
//             }
//         } catch (err) {
//             console.error("Delete error:", err);
//             setNotification("Server error while deleting");
//         }
//     };

//     const toggleSelectAll = () => {
//         if (selectedIds.length === users.length) {
//             setSelectedIds([]);
//         } else {
//             setSelectedIds(users.map((u) => u.UserId));
//         }
//     };

//     const filteredUsers = users.filter((user) =>
//         [user.UserName, user.EmployeeName, user.MobileNo, user.emailId, user.UserCategory]
//             .join(" ")
//             .toLowerCase()
//             .includes(searchQuery.toLowerCase())
//     );

//     const columns = [
//         {
//             field: "UserName",
//             headerName: "User Name",
//             flex: 1,
//             renderCell: (params) => (
//                 <Typography
//                     variant="body2"
//                     color="primary"
//                     sx={{ cursor: "pointer", textDecoration: "underline" }}
//                     onClick={() => goToEdit(params.row.UserId)}
//                 >
//                     {params.value}
//                 </Typography>
//             ),
//         },
//         { field: "EmployeeName", headerName: "Employee Name", flex: 1 },
//         { field: "MobileNo", headerName: "Mobile Number", flex: 1 },
//         { field: "emailId", headerName: "Email", flex: 1 },
//         { field: "UserCategory", headerName: "Category", flex: 1 },
//         userCategory !== "user" && {
//             field: "actions",
//             headerName: "Actions",
//             width: 80,
//             sortable: false,
//             align: "center",
//             renderCell: ({ row }) => {
//                 const isSelected = selectedIds.includes(row.UserId);
//                 return (
//                     <Tooltip title="Delete">
//                         <IconButton onClick={() => handleDelete(row.UserId)} disabled={!isSelected} color="error">
//                             <FaTrash />
//                         </IconButton>
//                     </Tooltip>
//                 );
//             },
//         },
//     ].filter(Boolean);

//     const renderCards = () => {
//         if (loading) return <Typography sx={{ p: 4, textAlign: "center" }}>Loading...</Typography>;
//         if (filteredUsers.length === 0) return <Typography sx={{ p: 4, textAlign: "center" }}>No users found.</Typography>;

//         return filteredUsers.map((row) => {
//             const isSelected = selectedIds.includes(row.UserId);
//             const avatarColor = stringToColor(row.UserName || "User");
//             const initials = getInitials(row.UserName);

//             const toggleSelection = (e) => {
//                 e.stopPropagation();
//                 setSelectedIds((prev) =>
//                     prev.includes(row.UserId)
//                         ? prev.filter((id) => id !== row.UserId)
//                         : [...prev, row.UserId]
//                 );
//             };

//             return (
//                 <Card
//                     key={row.UserId}
//                     onClick={() => goToEdit(row.UserId)}
//                     sx={{
//                         mb: 1.5,
//                         borderRadius: 2,
//                         borderLeft: 6,
//                         borderColor: "primary.main",
//                         bgcolor: "background.paper",
//                         boxShadow: 2,
//                         transition: "0.2s",
//                         "&:hover": { boxShadow: 4 },
//                         cursor: "pointer",
//                     }}
//                 >
//                     <CardContent sx={{ py: 2, px: 2.5, "&:last-child": { pb: 2 } }}>
//                         {/* Header Row: Checkbox + Avatar + UserName + EmployeeName */}
//                         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                             <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
//                                 {userCategory !== "user" && (
//                                     <Checkbox
//                                         checked={isSelected}
//                                         onChange={toggleSelection}
//                                         onClick={(e) => e.stopPropagation()}
//                                         size="small"
//                                         sx={{ mr: 1 }}
//                                     />
//                                 )}
//                                 <Avatar
//                                     sx={{
//                                         bgcolor: avatarColor,
//                                         width: 36,
//                                         height: 36,
//                                         fontWeight: "bold",
//                                         mr: 1.5,
//                                     }}
//                                 >
//                                     {initials}
//                                 </Avatar>
//                                 <Box sx={{ minWidth: 0, flex: 1 }}>
//                                     <Typography
//                                         variant="subtitle1"
//                                         sx={{ fontWeight: 600, lineHeight: 1.3 }}
//                                         noWrap
//                                     >
//                                         {row.UserName || "N/A"}
//                                     </Typography>
//                                     <Typography
//                                         variant="body2"
//                                         color="text.secondary"
//                                         noWrap
//                                     >
//                                         {row.EmployeeName || "N/A"}
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Box>

//                         {/* Contact Info Row 1: Mobile + Category */}
//                         <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2, mb: 1 }}>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <PhoneIcon fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />
//                                 <Typography variant="body2" sx={{ color: "text.secondary" }}>
//                                     {row.MobileNo || "N/A"}
//                                 </Typography>
//                             </Box>
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <PersonIcon fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />
//                                 <Typography variant="body2" sx={{ color: "text.secondary" }}>
//                                     {row.UserCategory || "N/A"}
//                                 </Typography>
//                             </Box>
//                         </Box>

//                         {/* Email Row */}
//                         <Box sx={{ display: "flex", alignItems: "center" }}>
//                             <EmailIcon fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />
//                             <Typography variant="body2" color="text.secondary" noWrap>
//                                 {row.emailId || "N/A"}
//                             </Typography>
//                         </Box>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Container maxWidth="xl" sx={{ py: 3 }}>
//             {/* Toolbar */}
//             <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
//                 <Grid item>
//                     <Box sx={{ display: "flex", gap: 1 }}>
//                         <Tooltip title="Add New">
//                             <IconButton onClick={addNewUser} sx={{ color: "orange" }}>
//                                 <VscNewFile />
//                             </IconButton>
//                         </Tooltip>
//                         <Tooltip title="Export to Excel">
//                             <IconButton onClick={funExportData} color="success">
//                                 <FaFileExcel />
//                             </IconButton>
//                         </Tooltip>
//                     </Box>
//                 </Grid>
//                 <Grid item xs>
//                     <Typography variant="h5" align="center" sx={{ fontWeight: 600 }}>
//                         User Details
//                     </Typography>
//                 </Grid>
//                 <Grid item />
//             </Grid>

//             <Paper elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
//                 <Box sx={{ p: { xs: 1.5, md: 2 } }}>
//                     {/* Search Bar */}
//                     <Box sx={{ mb: 2 }}>
//                         <TextField
//                             fullWidth
//                             size="small"
//                             placeholder="Search users..."
//                             value={searchQuery}
//                             onChange={(e) => setSearchQuery(e.target.value)}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <SearchIcon />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                             variant="outlined"
//                         />
//                     </Box>

//                     {/* Bulk Delete Bar (Mobile Only) */}
//                     {isMobile && userCategory !== "user" && selectedIds.length > 0 && (
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "space-between",
//                                 p: 1.5,
//                                 mb: 2,
//                                 bgcolor: "background.paper",
//                                 borderRadius: 2,
//                                 boxShadow: 1,
//                             }}
//                         >
//                             <Box sx={{ display: "flex", alignItems: "center" }}>
//                                 <Checkbox
//                                     checked={selectedIds.length === filteredUsers.length && filteredUsers.length > 0}
//                                     onChange={toggleSelectAll}
//                                 />
//                                 <Typography variant="body2">{selectedIds.length} selected</Typography>
//                             </Box>
//                             <Tooltip title="Delete selected">
//                                 <IconButton onClick={() => handleDelete()} color="error">
//                                     <DeleteIcon />
//                                 </IconButton>
//                             </Tooltip>
//                         </Box>
//                     )}

//                     {/* Content: Cards on Mobile, Table on Desktop */}
//                     {isMobile ? (
//                         <Box>{renderCards()}</Box>
//                     ) : (
//                         <Box sx={{ height: "80vh", width: "100%" }}>
//                             <DataGrid
//                                 rows={filteredUsers}
//                                 columns={columns}
//                                 getRowId={(row) => row.UserId}
//                                 checkboxSelection={userCategory !== "user"}
//                                 selectionModel={selectedIds}
//                                 onSelectionModelChange={(newSel) => setSelectedIds(newSel)}
//                                 loading={loading}
//                                 sx={{
//                                     "& .MuiDataGrid-columnHeaders": {
//                                         backgroundColor: "#165bb5",
//                                         color: "#FFFFFF",
//                                         fontWeight: "bold",
//                                     },
//                                     "& .MuiDataGrid-row:nth-of-type(odd)": { backgroundColor: "#FFFFFF" },
//                                     "& .MuiDataGrid-row:nth-of-type(even)": { backgroundColor: "#ecf4fc" },
//                                     "& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeaderTitle": { color: "#ffffff" },
//                                     "& .MuiDataGrid-columnHeader .MuiSvgIcon-root": { color: "#ffffff" },
//                                     "& .MuiDataGrid-columnHeader .MuiIconButton-root": { color: "#ffffff" },
//                                     "& .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon, & .MuiDataGrid-columnHeader .MuiDataGrid-filterIcon": {
//                                         color: "#ffffff",
//                                     },
//                                     "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": { outline: "none" },
//                                 }}
//                             />
//                         </Box>
//                     )}
//                 </Box>
//             </Paper>

//             {/* Notification Snackbar */}
//             <Snackbar
//                 open={!!notification}
//                 autoHideDuration={3000}
//                 onClose={() => setNotification("")}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert
//                     onClose={() => setNotification("")}
//                     severity={
//                         notification.includes("unauthorized")
//                             ? "warning"
//                             : notification.includes("fail") || notification.includes("error")
//                                 ? "error"
//                                 : "success"
//                     }
//                     sx={{ fontWeight: "bold" }}
//                 >
//                     {notification}
//                 </Alert>
//             </Snackbar>
//         </Container>
//     );
// }




import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import {
    Box, CircularProgress, IconButton, Paper, Typography, Checkbox, Snackbar,
    useTheme, useMediaQuery, Tooltip, Alert, Card, CardContent, Avatar,
    TextField, InputAdornment, Dialog, Button, Chip, Divider, LinearProgress,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { VscNewFile } from "react-icons/vsc";
import { FaFileExcel, FaTrash } from "react-icons/fa";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import PersonIcon from "@mui/icons-material/Person";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useAuth } from "../context/AuthContext";
import CommonServerDataGrid from "../components/datagridComponent";
import { formatRows } from "../utils/formatRows";
import NoDataComponent from "../components/NoDataComponent";
import CenterLoader from "../components/CenterLoader";
import CustomNoDataOverlay from "../components/CustomNoDataOverlay";
import SkeletonLoader from "../components/SkeletonLoader";
import LoadingOverlay from "../components/LoadingOverlay";
import { motion } from "framer-motion";

const PAGE_LIMIT = 50;

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ["#e74c3c", "#3498db", "#2ecc71", "#e67e22", "#9b59b6", "#1abc9c", "#3f51b5", "#e91e63", "#795548", "#00bcd4"];
    return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
    if (!name) return "U";
    return name.trim().charAt(0).toUpperCase();
}

export default function UserDetailsPage_v3({ connectionString }) {
    const { user, selectedCompany } = useAuth();
    const API_BASE = connectionString;
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    const [isFiltered, setIsFiltered] = useState(false);

    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const userCategory = user?.UserCategory || null;

    // ============ SHARED STATE ============
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selectionModel, setSelectionModel] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [selectAll, setSelectAll] = useState(false);

    // ============ DESKTOP STATE (CommonServerDataGrid) ============
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: PAGE_LIMIT });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // ============ MOBILE STATE ============
    const [mobileSearchQuery, setMobileSearchQuery] = useState("");
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState("");
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: PAGE_LIMIT });

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingDeleteIds, setPendingDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);

    // ============ PARAMETER BUILDERS ============
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = { mode: 'search', companyId, offset, limit: pageSize };

        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'UserName': params.userName = item.value; break;
                    case 'EmployeeName': params.employeeName = item.value; break;
                    case 'MobileNo': params.mobileNumber = item.value; break;
                    case 'emailId': params.emailId = item.value; break;
                    default: break;
                }
            }
        });

        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        return params;
    };

    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * PAGE_LIMIT;
        const params = { mode: 'search', companyId, offset, limit: PAGE_LIMIT };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        return params;
    };

    // ============ FETCH FOR DESKTOP ============
    const fetchDataDesktop = useCallback(async () => {
        if (isMobile) return;

        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);
            const dataRes = await axios.get(`${API_BASE}/api/userssearch`, { params });

            if (dataRes.data.success) {
                const fetchedRows = dataRes.data.users || [];
                setRows(formatRows(fetchedRows));

                const countParams = { ...params };
                delete countParams.mode;
                delete countParams.offset;
                delete countParams.limit;
                delete countParams.orderBy;

                const countRes = await axios.get(`${API_BASE}/api/userscount`, { params: countParams });
                setTotalCount(Number(countRes.data) || 0);
            } else {
                setSnackbar({ open: true, message: 'Failed to fetch users', severity: 'error' });
                setRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error('[DESKTOP] fetch error:', err);
            setSnackbar({ open: true, message: 'Server error', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API_BASE, companyId, paginationModel, filterModel, sortModel, isMobile]);

    // ============ FETCH FOR MOBILE ============
    const fetchDataMobile = useCallback(async () => {
        if (!isMobile) return;

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);
            const dataRes = await axios.get(`${API_BASE}/api/userssearch`, { params });

            if (dataRes.data.success) {
                const fetchedRows = dataRes.data.users || [];
                setRows(formatRows(fetchedRows));

                const countParams = { ...params };
                delete countParams.mode;
                delete countParams.offset;
                delete countParams.limit;

                const countRes = await axios.get(`${API_BASE}/api/userscount`, { params: countParams });
                setTotalCount(Number(countRes.data) || 0);
            } else {
                setSnackbar({ open: true, message: 'Failed to fetch users', severity: 'error' });
                setRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error('[MOBILE] fetch error:', err);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API_BASE, companyId, mobilePaginationModel, debouncedMobileSearch, isMobile]);

    // ============ EFFECTS ============
    useEffect(() => {
        if (!isMobile) fetchDataDesktop();
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isMobile, fetchDataDesktop]);

    useEffect(() => {
        if (isMobile) fetchDataMobile();
    }, [mobilePaginationModel, isMobile, fetchDataMobile]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: PAGE_LIMIT });
        }, 400);
        return () => clearTimeout(timer);
    }, [mobileSearchQuery]);

    useEffect(() => {
        if (isMobile) fetchDataMobile();
    }, [debouncedMobileSearch, isMobile, fetchDataMobile]);

    // ============ DELETE ============
    const handleDelete = async () => {
        if (deleting) return;
        if (userCategory === "user") {
            setSnackbar({ open: true, message: '403 Unauthorized', severity: 'warning' });
            return;
        }

        if (!pendingDeleteIds.length) {
            setSnackbar({ open: true, message: 'No users selected', severity: 'warning' });
            return;
        }

        setDeleting(true);
        try {
            const chk = await axios.post(`${API_BASE}/api/check-inquiry`, { userIds: pendingDeleteIds });
            if (chk.status === 400) {
                setSnackbar({ open: true, message: 'Cannot delete: inquiries exist', severity: 'error' });
                return;
            }

            const del = await axios.post(`${API_BASE}/api/delete-users`, { userIds: pendingDeleteIds, companyId });
            if (del.data.success) {
                setRows((prev) => prev.filter((u) => !pendingDeleteIds.includes(u.UserId)));
                setSelectionModel((prev) => prev.filter((id) => !pendingDeleteIds.includes(id)));
                setSnackbar({ open: true, message: 'Deleted Successfully.', severity: 'success' });

                if (isMobile) fetchDataMobile();
                else fetchDataDesktop();
            } else {
                setSnackbar({ open: true, message: del.data.message || 'Delete failed', severity: 'error' });
            }
        } catch (error) {
            const status = error.response?.status;
            const data = error.response?.data;
            if (status === 400 && data?.referencedIds?.length > 0) {
                setSnackbar({ open: true, message: "Cannot delete: item(s) are referenced in other records.", severity: "warning" });
            } else if (status === 400 && data?.message) {
                setSnackbar({ open: true, message: data.message, severity: "warning" });
            } else {
                setSnackbar({ open: true, message: "Delete failed due to an unexpected error.", severity: "error" });
            }
        } finally {
            setDeleting(false);
            setConfirmOpen(false);
            setPendingDeleteIds([]);
        }
    };

    // ============ EXPORT ============
    const funExportData = async () => {
        try {
            const res = await axios({ url: `${API_BASE}/api/export-users?companyId=${companyId}`, method: "GET", responseType: "blob" });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "UserDetailsExport.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            setSnackbar({ open: true, message: 'Export successful', severity: 'success' });
        } catch (err) {
            console.error("Export failed:", err);
            setSnackbar({ open: true, message: 'Export failed.', severity: 'error' });
        }
    };

    const goToEdit = (id) => navigate("/main/usermaster", { state: { mode: "edit", UserId: id } });
    const addNewUser = () => navigate("/main/usermaster", { state: { mode: "insert" } });

    const filteredMobileRows = useMemo(() => {
        if (!isMobile) return rows;
        if (!debouncedMobileSearch.trim()) return rows;

        const q = debouncedMobileSearch.toLowerCase();
        return rows.filter((row) => {
            const userName = row.UserName?.toLowerCase() || '';
            return (
                userName.startsWith(q) ||
                row.EmployeeName?.toLowerCase().includes(q)
            );
        });
    }, [rows, debouncedMobileSearch, isMobile]);

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectionModel([]);
            setSelectAll(false);
        } else {
            const allIds = filteredMobileRows.map(row => row.UserId);
            setSelectionModel(allIds);
            setSelectAll(true);
        }
    };

    // ============ COLUMNS ============
    const columns = [
        {
            field: "UserName", headerName: "User Name", flex: 1, minWidth: 130,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Typography sx={{ cursor: 'pointer', color: '#1877F2', textDecoration: 'underline', fontSize: '0.85rem' }} onClick={() => goToEdit(params.row.UserId)}>
                        {params.value}
                    </Typography>
                </Box>
            ),
        },
        {
            field: "EmployeeName", headerName: "Employee Name", flex: 1.2, minWidth: 180,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                    <Typography sx={{ whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '0.85rem' }}>
                        {params.value}
                    </Typography>
                </Box>
            ),
        },
        { field: "MobileNo", headerName: "Mobile Number", flex: 1, minWidth: 120 },
        {
            field: "emailId", headerName: "Email", flex: 1, minWidth: 190,
            renderCell: (params) => {
                if (!params.value) return "-";
                return (
                    <Tooltip title={params.value} arrow placement="top" slotProps={{ tooltip: { sx: { fontSize: "0.95rem" } } }}>
                        <Typography sx={{ fontSize: "0.85rem", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal", cursor: "pointer" }}>
                            {params.value}
                        </Typography>
                    </Tooltip>
                );
            },
        },
        { field: "UserCategory", headerName: "Category", flex: 0.8, minWidth: 120, filterable: false },
    ];

    if (userCategory !== 'User') {
        columns.push({
            flex: 0.1, minWidth: 80, sortable: false, filterable: false, headerAlign: 'right', align: 'right',
            renderCell: (params) => {
                const isRowSelected = selectionModel.includes(params.row.UserId);
                return (
                    <Tooltip title={isRowSelected ? 'Delete Selected' : 'Select row to enable'}>
                        <span>
                            <IconButton color="error"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setPendingDeleteIds(selectionModel.map(Number));
                                    setConfirmOpen(true);
                                }}
                                disabled={!isRowSelected}>
                                <FaTrash />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            },
        });
    }

    // ============ RENDER CARDS (MOBILE) ============
    const renderCards = () => {
        if (loading) {
            return <SkeletonLoader count={3} height={120} />;
        }

        if (filteredMobileRows.length === 0) {
            return (
                <Box sx={{ py: 4, textAlign: 'center' }}>
                    {mobileSearchQuery ? <CustomNoDataOverlay /> : <NoDataComponent />}
                </Box>
            );
        }

        return (
            <>
                {filteredMobileRows.map(row => {
                    const isSelected = selectionModel.includes(row.UserId);
                    const avatarColor = stringToColor(row.UserName || "User");
                    const initials = getInitials(row.UserName);

                    return (
                        <Card
                            key={row.UserId}
                            onClick={() => goToEdit(row.UserId)}
                            sx={{ mb: 1.5, borderRadius: 2, boxShadow: 1, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 3 }, cursor: 'pointer' }}
                        >
                            <Box sx={{ height: 4, background: `linear-gradient(90deg, ${avatarColor}, ${avatarColor}88)` }} />
                            <CardContent sx={{ py: 1.5, px: 1.5, '&:last-child': { pb: 1.5 } }}>
                                {/* Header row */}
                                <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                                    {userCategory !== 'User' && (
                                        <Checkbox
                                            size="small"
                                            sx={{ mr: 0.5, p: 0.5, mt: -0.3, flexShrink: 0 }}
                                            checked={isSelected}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectionModel(p => p.includes(row.UserId) ? p.filter(id => id !== row.UserId) : [...p, row.UserId]);
                                            }}
                                        />
                                    )}
                                    <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 38, height: 38, fontWeight: 'bold', mr: 1.5, fontSize: '1rem', flexShrink: 0 }}>
                                        {initials}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0, flex: 1 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1976d2', fontSize: '0.95rem', lineHeight: 1.3 }} noWrap>
                                            {row.UserName || '—'}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" noWrap>
                                            {row.EmployeeName || '—'}
                                        </Typography>
                                    </Box>
                                </Box>

                                <Divider sx={{ my: 0.8 }} />

                                {/* Info chips */}
                                <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap', mt: 0.5 }}>
                                    <Chip
                                        icon={<PersonIcon sx={{ fontSize: '0.85rem !important' }} />}
                                        label={row.UserCategory || 'N/A'}
                                        size="small"
                                        color="primary"
                                        sx={{ height: 22, fontSize: '0.75rem' }}
                                    />
                                    {row.MobileNo && (
                                        <Chip
                                            icon={<PhoneIcon sx={{ fontSize: '0.85rem !important' }} />}
                                            label={row.MobileNo}
                                            size="small"
                                            variant="outlined"
                                            sx={{ height: 22, fontSize: '0.75rem' }}
                                        />
                                    )}
                                    {row.emailId && (
                                        <Chip
                                            icon={<EmailIcon sx={{ fontSize: '0.85rem !important' }} />}
                                            label={row.emailId}
                                            size="small"
                                            variant="outlined"
                                            sx={{ height: 22, fontSize: '0.75rem', maxWidth: '100%' }}
                                        />
                                    )}
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* Pagination */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 1 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<NavigateBeforeIcon />}
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1) }))}
                        disabled={mobilePaginationModel.page === 0}
                    >
                        Prev
                    </Button>
                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100, textAlign: 'center' }}>
                        Page {mobilePaginationModel.page + 1} of {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        endIcon={<NavigateNextIcon />}
                        onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))}
                        disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount}
                    >
                        Next
                    </Button>
                </Box>
            </>
        );
    };

    // ============ RENDER ============
    return (
        <Box sx={{ pt: 1, px: { xs: 1.5, sm: 2 } }}>

            {/* Page Header */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        User Details
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        {selectionModel.length > 0 && userCategory !== 'User' && (
                            <Button
                                variant="outlined"
                                size="small"
                                color="error"
                                startIcon={<DeleteIcon />}
                                onClick={() => { setPendingDeleteIds(selectionModel.map(Number)); setConfirmOpen(true); }}
                            >
                                {isSmallDevice ? selectionModel.length : `Delete (${selectionModel.length})`}
                            </Button>
                        )}
                        <Button
                            variant="outlined"
                            size="small"
                            color="success"
                            startIcon={<FaFileExcel style={{ fontSize: '0.9rem' }} />}
                            onClick={funExportData}
                        >
                            {!isSmallDevice && 'Export'}
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<VscNewFile style={{ fontSize: '0.9rem' }} />}
                            onClick={addNewUser}
                        >
                            {isSmallDevice ? '' : 'Add User'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            {/* Content Card */}
            <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>

                {/* Search – mobile only */}
                {isMobile && (
                    <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            placeholder="Search by name, mobile..."
                            value={mobileSearchQuery}
                            onChange={(e) => setMobileSearchQuery(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                )}

                {/* Bulk delete bar – mobile only */}
                {isMobile && userCategory !== 'User' && selectionModel.length > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 1.5, py: 1, mx: 1.5, mb: 1, bgcolor: 'rgba(211,47,47,0.06)', borderRadius: 1.5, border: '1px solid rgba(211,47,47,0.2)' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Checkbox checked={selectAll} onChange={toggleSelectAll} size="small" color="error" />
                            <Typography variant="body2" sx={{ color: 'error.main', fontWeight: 500 }}>
                                {selectionModel.length} selected
                            </Typography>
                        </Box>
                        <Button
                            variant="contained"
                            size="small"
                            color="error"
                            startIcon={<DeleteIcon />}
                            onClick={() => { setPendingDeleteIds(selectionModel.map(Number)); setConfirmOpen(true); }}
                        >
                            Delete
                        </Button>
                    </Box>
                )}

                {/* Main content */}
                {isMobile ? (
                    <Box sx={{ px: 1.5, pb: 1.5 }}>
                        {rows?.length === 0 && !loading ? <NoDataComponent /> : renderCards()}
                    </Box>
                ) : (
                    <Box sx={{ height: '81.5vh', width: '100%', position: 'relative' }}>
                        <LoadingOverlay isVisible={loading} />
                        {rows?.length === 0 && !isFiltered && <NoDataComponent />}
                        {rows?.length > 0 && <CommonServerDataGrid
                                data={rows}
                                columns={columns}
                                getRowHeight={() => "auto"}
                                getRowId={(row) => row.UserId}
                                role={userCategory}
                                pageSizeOptions={[25, 50, 100]}
                                selectionModel={selectionModel}
                                onSelectionModelChange={setSelectionModel}
                                onPageChange={({ page, pageSize }) => setPaginationModel({ page, pageSize })}
                                onFilterChange={setFilterModel}
                                onSortChange={setSortModel}
                                rowCount={totalCount}
                                onFilterStatusChange={setIsFiltered}
                            />
                        }
                    </Box>
                )}
            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} variant="filled" onClose={() => setSnackbar(s => ({ ...s, open: false }))}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {/* Confirm Delete Dialog */}
            <Dialog open={confirmOpen} onClose={() => { if (!deleting) setConfirmOpen(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>
                        Confirm Deletion
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">
                            {pendingDeleteIds.length}
                        </Typography>
                        {' '}user{pendingDeleteIds.length !== 1 ? 's' : ''}? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setConfirmOpen(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>
                        Cancel
                    </Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={handleDelete}>
                        {deleting ? 'Deleting…' : 'Delete'}
                    </Button>
                </Box>
            </Dialog>

        </Box>
    );
}
